import React, { useEffect } from 'react';
import './css/footer.css';
import contact from '../../data/layouts/contact';
import { Link } from 'react-router-dom';
import getValue from '../../format/getValue';

const Footer = ({ infoCompany, contactItems, combinedData, infoFooter }) => {
  useEffect(() => {
    window.FB?.XFBML.parse();
  }, []);

  const policy = infoFooter?.filter((item) => item.key === 'policy');

  const aboutCompany = infoFooter?.find((item) => item.key === 'about_company');
  const facebookValue = getValue(infoCompany, 'facebook');

  return (
    <footer className="footer">
      <div
        className="layer"
        data-bg="url(/images/statistics.webp)"
        style={{
          backgroundImage: 'url("/images/wavy-curve.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-4 col-md-6 position-relative">
              <Link
                className="logo"
                to="/"
                title={getValue(infoCompany, 'name').value}
              >
                <img
                  src={contact.logo}
                  alt={getValue(infoCompany, 'name').value}
                  loading="lazy"
                />
              </Link>

              <h3>Thông tin liên hệ</h3>

              {contactItems.map((item, index) => (
                <div className="text-white mb-1" key={index}>
                  <img
                    src={`/images/icons/${item.icon}`}
                    alt={item.data.title}
                    style={{
                      width: '16px',
                      maxHeight: '20px',
                      marginRight: '5px',
                    }}
                    loading="lazy"
                  />
                  {item.data.value}
                </div>
              ))}

              <div className="social-networks mb-md-0 ">
                {combinedData.map(
                  (network, index) =>
                    network.iconWhite && (
                      <Link
                        key={index}
                        className="me-2 me-sm-2"
                        to={network.url}
                        title={network.name}
                        target="_blank"
                      >
                        <img
                          src={network.iconWhite}
                          alt={network.name}
                          className="icon"
                          loading="lazy"
                        />
                      </Link>
                    )
                )}
              </div>
            </div>

            <div className="footer_column col-lg-4 col-md-6 mt-4">
              <div className="our-agency">
                <h3>Chính sách</h3>
                <ul>
                  {policy?.map((item, index) => (
                    <li key={index} className="mb-1">
                      <Link
                        className="link-policy"
                        to={`${item.url}`}
                        title={item.title}
                      >
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className="fb-page mt-auto w-100"
                data-href={facebookValue?.url || ''}
                data-tabs="timeline"
                data-height="130"
                data-small-header="false"
                data-adapt-container-width="true"
                data-hide-cover="false"
                data-show-facepile="true"
              ></div>
            </div>

            <div className="  col-lg-4 col-md-12 pl-lg-0 mt-4">
              <div
                className="row d-flex flex-column footer_column"
                style={{ minHeight: '100%', flexGrow: 1 }}
              >
                <div className="footer_third col-lg-12 col-md-6">
                  <h3>{aboutCompany?.title}</h3>
                  <div className="text-white" style={{ textAlign: 'justify' }}>
                    <div>
                      <span>{aboutCompany?.value}</span>
                    </div>
                  </div>
                </div>

                <div
                  className="footer_third_end  mt-auto col-lg-12 col-md-6 "
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '20px',
                  }}
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4506.649423919678!2d105.76356609999999!3d10.0488796!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31a0880c10e2bf21%3A0xf0ba66dafcbae9c6!2zNjYgxJAuIE5ndXnhu4VuIMSQ4buHLCBBbiBIb8OgLCBCw6xuaCBUaOG7p3ksIEPhuqduIFRoxqE!5e1!3m2!1svi!2s!4v1742964403431!5m2!1svi!2s"
                    width="100%"
                    height="130"
                    style={{ border: 'none' }}
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="copyright">
            <p className="p-0 text-end sub-footer">
              Design by{' '}
              <Link
                to="https://katec.vn"
                title="katec.vn"
                className="text-white fw-bold"
                target="_blank"
              >
                Katec.vn
              </Link>
            </p>
          </div>*/}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
